// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"156":"71f192d7","311":"ec130a22"}[chunkId] + ".css";
};